import { render, staticRenderFns } from "./TopFeatureStrip.vue?vue&type=template&id=2d9374df&scoped=true"
import script from "./TopFeatureStrip.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopFeatureStrip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopFeatureStrip.vue?vue&type=style&index=0&id=2d9374df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9374df",
  null
  
)

export default component.exports